<header class="header" [class.header--is-collapse]="isCollapse" [ngStyle]="{'background-image': backgroundImage}">

  <div class="header__wrapper" [class.header__wrapper--is-collapse]="isCollapse" *ngIf="!isStoneCreek|| !isMobile">
    <div class="header__container">
      <div class="header__top-container">
        <div class="header__store" *ngIf="!isGroup; else groupHeader">
          <p class="header__store-btn-back" (click)="goToHomePage()" *ngIf="showBackToLocationsButton">Back to locations</p>
          <div *ngIf="isStoneCreek">
           <ion-menu-button class="desktop-menu"></ion-menu-button>
            <p class="header__store-btn-back"
               (click)="backToShop()"
               *ngIf="isCreek">
              Back to locations
            </p>
          </div>
          <ng-container *ngIf="!isCollapse">
            <ng-container *ngTemplateOutlet="headerTopInfoTemplate"></ng-container>
            <div class="header__store-name-container">
              <p class="header__store-line header__store-name">{{ name }}</p>
              <p *ngIf="showAllLocationsButton" class="header__store-btn-back header__store-btn-back--mobile"
                 (click)="goToHomePage()">All locations</p>
            </div>
            <p class="header__store-header-title" *ngIf="!isMobile">{{ headerTitle }}
              <span class="header__store-header-text" [innerHTML]="headerText"></span>
              <span class="header__store-header-see-more" *ngIf="showSeeMoreText" (click)="showFullHeaderText()">see more</span>
            </p>
            <div *ngIf="isMobile && headerTitle"
                 #headerTextButton
                 class="title-button"
                 (click)="showHeaderText($event)"
                 [class.title-button--brand]="isHeaderTextPopoverOpen">
              <div class="title-button__text">{{ headerTitle }}</div>
            </div>
            <div *ngIf="isMobile">
              <div class="cart qr-wrap" *ngIf="sharedOrderService.sharedOwnerId$" (click)="sharedOrderService.openSharedOrderViewModal()">
                <img class="qr-icon" src="assets/icon/qr-code-scan.png">
              </div>
            </div>
            <div *ngIf="isMobile && isTab" class="order" (click)="openCloseTabPage()">
              <p class="order__text">Close Tab</p>
            </div>
            <p *ngIf="address.length > 0" class="header__store-line header__store-address">{{ address }}</p>
          </ng-container>
        </div>
        <ng-template #groupHeader>
          <ng-container *ngTemplateOutlet="headerTopInfoTemplate"></ng-container>
          <div class="header__store header__store-group-mobile" *ngIf="isMobile && !isCollapse">
            <div class="header__store-group-mobile-line">
              <p class="header__store-line header__store-group-name">{{ name }}</p>
              <a class="header__store-icon-location" (click)="openLocationInMaps(group?.address)">
                <img class="header__store-icon-img" src="./assets/icon/location_in_circle_icon.svg" alt="logo">
              </a>
              <a class="header__store-icon-phone" href="tel:{{formatPhoneNumber(group?.phoneNumber, 'international')}}">
                <img class="header__store-icon-img" src="./assets/icon/phone_in_circle_icon.svg" alt="logo">
              </a>
            </div>
            <div class="title-button" #headerTextButton *ngIf="headerTitle" (click)="showHeaderText($event)" [class.title-button--brand]="isHeaderTextPopoverOpen">
              <div class="title-button__text">{{ headerTitle }}</div>
            </div>
            <div *ngIf="isMobile && isTab" class="order" (click)="openCloseTabPage()">
              <p class="order__text">Close Tab</p>
            </div>
            <p *ngIf="address.length > 0" class="header__store-line header__store-address">{{ address }}</p>
          </div>
        </ng-template>
        <div *ngIf="showRightButtons" class="right-buttons">
          <div #ordersButton *ngIf="ShowOrdersAheadButton" class="order" [ngClass]="{
                     'order--gray': queueInfo ? queueInfo.placeInLine === 1 : false,
                     'order--green': queueInfo ? queueInfo.placeInLine < 5 && queueInfo.placeInLine > 1 : false,
                     'order--red': queueInfo ? queueInfo.placeInLine >= queueInfo.maxOrdersInQueue : false}"
              (click)="showOrdersAhead($event)">
              <p class="order__text">Orders ahead</p>
              <!-- <p class="order__text">{{ queueInfo?.numPersonsAhead }} orders ahead</p> -->
              <p class="order__text" *ngIf="!hideETA">
                (~{{leadTimeService.convertLeadTimeToMinutes(queueInfo?.estimatedTimeToBeginPreparation)}} min wait)
              </p>
            </div>
            <div *ngIf="isTab" class="order" (click)="openCloseTabPage()">
              <p class="order__text">Close Tab</p>
            </div>
            <div #tabsButton *ngIf="isTab" class="order" (click)="showOrdersInTab($event)">
              <p class="order__text">{{paymentStore.customer?.givenName}}'s tab</p>
            </div>

          <div #chartButton
               class="cart"
               (click)="showCart($event)"
               [class.cart--brand]="isCartOpen"
               [class.cart--disabled]="cartStore.items.length === 0">
            <div class="cart__container">
              <ion-icon class="cart__image" name="cart"></ion-icon>
              <div class="cart__counter">{{ cartStore.totalQuantity }} item(s)</div>
            </div>
          </div>
          <div class="cart" *ngIf="sharedOrderService.sharedOwnerId$" (click)="sharedOrderService.openSharedOrderViewModal()">
            <img class="qr-icon" src="assets/icon/qr-code-scan.png">
          </div>
        </div>
      </div>
      <ng-container *ngIf="isGroup">
        <div class="header__bottom-container" *ngIf="!isMobile; else mobileBottomGroup" [ngStyle]="{'margin': isCollapse ? '2rem 0' : '9rem 0 2rem 0'}">
          <span class="header__bottom-container-label" *ngIf="!isCollapse">Order from</span>
          <div class="container__content unscrollable-content">
            <div *ngIf="showLocationsListLeftArrow" class="locations__arrow-wrapper">
              <div class="locations__arrow locations__arrow--left">
                <ion-icon class="locations__arrow-size" name="arrow-back" mode="ios" (click)="scrollToPreviousCategoryTabs()"></ion-icon>
              </div>
            </div>
            <div #locationsWrapper class="locations__wrapper">
              <ul #locationsTabContainer class="locations">
                <li #locationsTab class="locations__item" *ngFor="let location of restaurantsInGroup; index as i; last as isLast">
                  <button type="button" class="locations__btn"
                          [class.locations__btn--active]="activeLocationIndex === i"
                          [ngStyle]="{'background-image': formatToStyleImageUrl(getLocationBanner(location))}"
                          [disabled]="!location.isMobileEnabled"
                          (click)="chooseLocation(i)"
                  >
                    {{location.name}}
                  </button>
                </li>
              </ul>
            </div>
            <div *ngIf="showLocationsListRightArrow" class="locations__arrow-wrapper">
              <div class="locations__arrow locations__arrow--right">
                <ion-icon class="locations__arrow-size" name="arrow-forward" mode="ios" (click)="scrollToNextCategoryTabs()"></ion-icon>
              </div>
            </div>
          </div>
        </div>
        <ng-template #mobileBottomGroup>
          <div class="header__bottom-mobile-container" *ngIf="!isCollapse" (click)="chooseLocationMobile()">
            <div class="group-choose__button">
              <div class="group-choose__button-left">
                <img class="group-choose__button-left-image" [src]="activeLocationBanner" alt="logo">
                <span class="group-choose__button-left-text">{{activeLocationName}}</span>
              </div>
              <img class="group-choose__button-arrows" src="./assets/icon/up_down_icon_dark.svg" alt="dropdown"/>
            </div>
          </div>
          <div class="group-choose__button-collapsed" *ngIf="isCollapse" [ngStyle]="{'background-image': formatToStyleImageUrl(activeLocationBanner)}" (click)="chooseLocationMobile()">
            <span class="group-choose__button-collapsed-text">{{activeLocationName}}</span>
            <img class="group-choose__button-collapsed-icon" src="./assets/icon/up_down_icon.svg" alt="logo">
          </div>
        </ng-template>
      </ng-container>
      <div>
        <ng-content></ng-content>
      </div>
    </div>
  </div>

  <div  class="header__wrapper"
        [class.header__wrapper--is-collapse]="isCollapse"
        [ngClass]="{'display-none': isStoneCreek && isCollapse}"
        *ngIf="isStoneCreek && isMobile">
   <div class="header__container">
    <div class="header__store header__store-group" *ngIf="!isMobile">
      <div class="header__near-image">
        <p class="header__store-line header__store-group-name">{{ name }}</p>
        <p class="header__store-header-title" *ngIf="!isMobile">{{ headerTitle }}
          <span class="header__store-header-text" [innerHTML]="headerText"></span>
          <span class="header__store-header-see-more" *ngIf="showSeeMoreText" (click)="showFullHeaderText()">see more</span>
        </p>
        <ng-container *ngTemplateOutlet="locationModal"></ng-container>
      </div>
      <ion-menu-button class="side-menu"></ion-menu-button>
    </div>
    <div class="header__store header__store-group-mobile" *ngIf="isMobile && !isCollapse">
      <div class="header__image-container header__image-container--group" *ngIf="logo" (click)="navigateToHome()">
        <img class="header__image" [src]="logo" alt="logo">
      </div>

      <div class="header__store-group-mobile-line">
        <ion-menu-button class="side-menu"></ion-menu-button>
      </div>
      <div *ngIf="isMobile && isTab" class="order" (click)="openCloseTabPage()">
        <p class="order__text">Close Tab</p>
      </div>
      <ng-container *ngTemplateOutlet="locationModal"></ng-container>
      <div class="title-button" #headerTextButton *ngIf="headerTitle" (click)="showHeaderText($event)"
        [class.title-button--brand]="isHeaderTextPopoverOpen">
        <div class="title-button__text">{{ headerTitle }}</div>
      </div>
    </div>
   </div>
  </div>
</header>

<!-- ============ LOGO + ICONS TEMPLATE =========== -->
<ng-template #headerTopInfoTemplate>
  <div class="header__store {{isGroup ? 'header__store-group' : 'header__store-restaurant'}}"
    *ngIf="!(isGroup && isMobile) && !isMerchantPage">
    <div class="header__image-container header__image-container{{isGroup ? '--group' : '--location'}}" *ngIf="logo">
      <img class="header__image" [src]="logo" alt="logo">
    </div>
    <div class="header__near-image" *ngIf="isGroup">
      <p class="header__store-line header__store-group-name">{{ name }}</p>
      <p class="header__store-header-title" *ngIf="!isMobile">{{ headerTitle }}
        <span class="header__store-header-text" [innerHTML]="headerText"></span>
        <span class="header__store-header-see-more" *ngIf="showSeeMoreText" (click)="showFullHeaderText()">see more</span>
      </p>
      <p *ngIf="address.length > 0" class="header__store-line header__store-address">{{ address }}</p>
      <p *ngIf="group?.phoneNumber" class="header__store-line header__store-phone">
        <a class="header__store-phone-link" href="tel:{{formatPhoneNumber(group?.phoneNumber, 'international')}}">{{formatPhoneNumber(group?.phoneNumber, 'national')}}</a>
      </p>
    </div>
    <div>
      <a class="header__store-icon-location" (click)="openLocationInMaps(isGroup ? group?.address : chosenRestaurant?.address)">
        <img src="./assets/icon/location_in_circle_icon.svg" alt="logo">
      </a>
    </div>
    <div *ngIf="chosenRestaurant?.contactPhoneNumber">
      <a class="header__store-icon-phone" href="tel:{{formatPhoneNumber(isGroup ? group?.phoneNumber : chosenRestaurant?.contactPhoneNumber, 'international')}}">
        <img src="./assets/icon/phone_in_circle_icon.svg" alt="logo">
      </a>
    </div>
  </div>
   <div class="header__store header__store-restaurant" *ngIf="isStoneCreek && showMerchantLogo &&!isMobile">
    <div class="header__image-container header__image-container--location" *ngIf="logo">
      <img class="header__image" [src]="logo" alt="logo">
    </div>
   </div>
</ng-template>

<!-- ============ Location-Modal Template =========== -->
<ng-template #locationModal>
  <ion-row class="location-row" *ngIf="showLocationModal">
    <ion-col size="8">
      <div class="location-list">
        <ion-button expand="block" class="select-location" (click)="openLocationModal()">
          <div class="selected-location">
            <ion-col size="11" class="location-text">
              <ion-text class="location-name">{{ name }}</ion-text>
              <ion-text class="location-address">{{ address }}</ion-text>
            </ion-col>
            <ion-col size="1">
              <ion-icon name="md-arrow-dropdown"></ion-icon>
            </ion-col>
          </div>
        </ion-button>
      </div>
    </ion-col>
      <ion-col size="2">
        <a ca class="header__store-icon-location" (click)="openLocationInMaps(chosenRestaurant?.address)">
              <img src="./assets/icon/right-arrow.svg" alt="logo">
           </a>
      </ion-col>
      <ion-col *ngIf="chosenRestaurant?.contactPhoneNumber" size="2">
        <a class="header__store-icon-phone" href="tel:{{formatPhoneNumber(chosenRestaurant?.contactPhoneNumber, 'international')}}" *ngIf="!hidePhoneIcon">
                <img src="./assets/icon/phone_in_circle_icon.svg" alt="logo">
              </a>
      </ion-col>
  </ion-row>
</ng-template>
